import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VehicleType, WhiteListRequest, WhiteListResponse, WhiteListStateModel } from './models';
import { deleteWhiteListEntry, exportData, fetchVehicleTypes, fetchWhiteListRows } from './operations';

const initialState = {
  data: {} as WhiteListResponse,
  vehicleTypes: [] as VehicleType[],
  openDialog: false,
  filters: { pageSize: 10, page: 0 },
  isLoading: false,
} as WhiteListStateModel;

const whiteListSlice = createSlice({
  name: 'white-list',
  initialState: initialState,
  reducers: {
    setFilters(state, action: PayloadAction<WhiteListRequest>) {
      state.filters = action.payload;
    },
    setSelectedEntry: (state, action) => {
      state.entry = action.payload;
    },
    openDialog: (state) => {
      state.openDialog = true;
    },
    closeDialog: (state) => {
      state.openDialog = false;
      state.entry = undefined;
    },
    setLocation: (state, action: PayloadAction<string>) => {
      state.filters.locationUuidFilter = action.payload;
    },
    setMainLocation: (state, action: PayloadAction<string>) => {
      state.filters.mainLocationId = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchWhiteListRows.pending, (state) => {
      state.isLoading = true;
      state.data = {} as WhiteListResponse;
    });
    builder.addCase(fetchWhiteListRows.fulfilled, (state, action: PayloadAction<WhiteListResponse>) => {
      state.data = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchWhiteListRows.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(fetchVehicleTypes.fulfilled, (state, action: PayloadAction<VehicleType[]>) => {
      state.vehicleTypes = action.payload;
    });
    builder.addCase(deleteWhiteListEntry.fulfilled, (state, action: PayloadAction<string>) => {
      const index = state.data.content.findIndex((x) => x.uuid == action.payload);
      state.data.content.splice(index, 1);
    });
    builder
      .addCase(exportData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(exportData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(exportData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setSelectedEntry, openDialog, closeDialog, setFilters, setLocation, setMainLocation } = whiteListSlice.actions;

export default whiteListSlice.reducer;
